export interface RedPackInput {
  msg: string;
  expire: number;
}

export interface RedPackInputJSON {
  [key: string]: RedPackInput
}

export function useStorage () {
  const saveRedpackInputKey = 'redpackInput'

  function saveRedpackInput (data: {
    id: string;
    msg: string;
    expire: number;
  }) {
    const findStorage = localStorage.getItem(saveRedpackInputKey)

    let redpackJSON: RedPackInputJSON = {}

    if (findStorage) {
      redpackJSON = JSON.parse(findStorage)
    }

    redpackJSON[data.id] = {
      msg: data.msg,
      expire: data.expire
    }

    localStorage.setItem(saveRedpackInputKey, JSON.stringify(redpackJSON))
  }

  function findRedpackInput (data: {
    id: string
  }) {
    const storage = localStorage.getItem(saveRedpackInputKey)

    if (!storage) return null

    const storageJSON = JSON.parse(storage) as RedPackInputJSON

    return storageJSON[data.id]
  }

  function clearExpireRedpackInput () {
    const storage = localStorage.getItem(saveRedpackInputKey)

    if (!storage) return

    const storageJSON = JSON.parse(storage) as RedPackInputJSON

    for (const [key, value] of Object.entries(storageJSON)) {
      if (Date.now() > value.expire) {
        Reflect.deleteProperty(storageJSON, key)
      }
    }

    localStorage.setItem(saveRedpackInputKey, JSON.stringify(storageJSON))
  }

  return {
    saveRedpackInput,
    findRedpackInput,
    clearExpireRedpackInput
  }
}
